import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@mui/styles';
import { useMediaQuery, Grid2 as Grid, Typography } from '@mui/material';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';

const useStyles = makeStyles(() => ({
  image: {
    maxWidth: 420,
    borderRadius: '24px',
  },
}));

const TrustedPartner = props => {  
  const { className, ...rest } = props;

  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <Grid
        container
        justify="space-between"
        spacing={isMd ? 4 : 2}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          justify={isMd ? 'flex-end' : 'flex-start'}
          alignItems="center"
          size={{ xs: 12, md: 6 }}
          data-aos={'fade-up'}
        >
          <Image
            src="/assets/ondc/mperito_ondc_trusted_partner.png"
            alt="One Stop eCommerce Solution"
            className={classes.image}
          />
        </Grid>
        <Grid
          item
          container
          alignItems="center"
          justify="flex-start"
          size={{ xs: 12, md: 6 }}
          data-aos={'fade-up'}
        >
          <div>
            <SectionHeader
              title="Mperito: Your Trusted ONDC Partner"
              subtitle=" "
              align="left"
              disableGutter
              subtitleProps={{
                color: 'textPrimary',
                variant: 'body1',
              }}
            />
            <Typography
              variant="body1"
              align="justify"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }}
              color="textPrimary"
              className=""
            >
              As a certified Seller-side Technology Service Provider (TSP) for ONDC, Mperito eliminates the technical complexity of joining India's most exciting e-commerce revolution.              
            </Typography>
            <Typography
              variant="body1"
              align="justify"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }}
              color="textPrimary"
              className=""
            >
              Our comprehensive solution ensures your business is fully integrated across all aspects of the ONDC ecosystem - from catalogue management to order processing, logistics coordination to payment reconciliation.
            </Typography>
            <Typography
              variant="body1"
              align="justify"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }}
              color="textPrimary"
              className=""
            >
              With real-time analytics and dedicated support at every step, we've designed our service to maximise your sales potential whilst minimising your operational overhead.
            </Typography>
            {/* <Typography
              variant="h6"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }} 
              color="textPrimary"
              className=""
            >
              That was the starting point of MindsClik…
            </Typography> */}
          </div>
        </Grid>
        
      </Grid>
    </div>
  );
};

TrustedPartner.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default TrustedPartner;
